(() => {
  const initProductReviews = (reviewsRoot) => {
    if (!reviewsRoot || reviewsRoot.dataset.productReviewsInitialized === 'true') return;

    reviewsRoot.dataset.productReviewsInitialized = 'true';

    // SET REVIEW DOM REFERENCES
    const reviewsContainer = reviewsRoot.querySelector(':scope > .container');
    if (!reviewsContainer) return;

    const reviewsSwiperEl = reviewsRoot.querySelector('.reviews-swiper');
    const reviewsMobileQuery = window.matchMedia('(max-width: 719px)');
    const hasReviewSlider = Boolean(reviewsSwiperEl && window.Swiper);

    // INITIALIZE REVIEW SLIDER
    const getReviewsOffset = () => {
      if (reviewsMobileQuery.matches) return 0;

      const containerStyles = getComputedStyle(reviewsContainer);
      return reviewsContainer.getBoundingClientRect().left + parseFloat(containerStyles.paddingLeft);
    };
    const reviewsSwiper = hasReviewSlider ? new Swiper(reviewsSwiperEl, {
      slidesPerView: 1.25,
      slidesOffsetBefore: getReviewsOffset(),
      spaceBetween: 0,
      grabCursor: true,
      freeMode: {
        enabled: true,
        sticky: true
      },
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        sensitivity: 1
      },
      scrollbar: {
        el: reviewsRoot.querySelector('.reviews-scrollbar'),
        draggable: true
      },
      breakpoints: {
        720: {
          slidesPerView: 2.1,
          spaceBetween: 44
        },
        1100: {
          slidesPerView: 3.45,
          spaceBetween: 64
        }
      }
    }) : null;
    if (reviewsSwiper) {
      window.addEventListener('resize', () => {
        reviewsSwiper.params.slidesOffsetBefore = getReviewsOffset();
        reviewsSwiper.update();
      });
    }

    // CACHE MODAL AND FORM ELEMENTS
    const reviewsReadMoreOverlay = reviewsRoot.querySelector('.reviews-read-more-overlay');
    if (reviewsReadMoreOverlay && reviewsReadMoreOverlay.parentElement !== document.body) {
      document.body.appendChild(reviewsReadMoreOverlay);
    }
    const reviewsReadMoreContent = reviewsReadMoreOverlay ? reviewsReadMoreOverlay.querySelector('.reviews-read-more-content') : null;
    const reviewsReadMoreClose = reviewsReadMoreOverlay ? reviewsReadMoreOverlay.querySelector('.reviews-read-more-close') : null;
    const reviewsReadMoreStars = reviewsReadMoreOverlay ? reviewsReadMoreOverlay.querySelector('#reviews-read-more-stars') : null;
    const reviewsReadMoreInfoIcon = reviewsReadMoreOverlay ? reviewsReadMoreOverlay.querySelector('#reviews-read-more-info-icon') : null;
    const reviewsReadMoreSource = reviewsReadMoreOverlay ? reviewsReadMoreOverlay.querySelector('#reviews-read-more-source') : null;
    const reviewsReadMoreTitle = reviewsReadMoreOverlay ? reviewsReadMoreOverlay.querySelector('#reviews-read-more-title') : null;
    const reviewsReadMoreText = reviewsReadMoreOverlay ? reviewsReadMoreOverlay.querySelector('#reviews-read-more-text') : null;
    const reviewsReadMoreReviewerWrap = reviewsReadMoreOverlay ? reviewsReadMoreOverlay.querySelector('.reviewer') : null;
    const reviewsReadMoreReviewer = reviewsReadMoreOverlay ? reviewsReadMoreOverlay.querySelector('#reviews-read-more-reviewer') : null;
    const reviewsReadMoreReviewerTitle = reviewsReadMoreOverlay ? reviewsReadMoreOverlay.querySelector('#reviews-read-more-reviewer-title') : null;
    const reviewsReadMoreReply = reviewsReadMoreOverlay ? reviewsReadMoreOverlay.querySelector('.reviews-read-more-reply') : null;
    const reviewsReadMoreReplyText = reviewsReadMoreOverlay ? reviewsReadMoreOverlay.querySelector('#reviews-read-more-reply-text') : null;
    const reviewsSubmitOverlay = reviewsRoot.querySelector('.reviews-submit-overlay');
    if (!reviewsSubmitOverlay) return;
    if (reviewsSubmitOverlay.parentElement !== document.body) {
      document.body.appendChild(reviewsSubmitOverlay);
    }
    const reviewsSubmitButton = reviewsRoot.querySelector('.reviews-submit-button');
    const reviewsEmptyCta = reviewsRoot.querySelector('.reviews-empty-cta');
    const reviewsSubmitTitle = reviewsSubmitOverlay.querySelector('.reviews-submit-title');
    const reviewsSubmitClose = reviewsSubmitOverlay.querySelector('.reviews-submit-close');
    const reviewsSubmitForm = reviewsSubmitOverlay.querySelector('.reviews-submit-form');
    const reviewsSubmitRatingValue = reviewsSubmitOverlay.querySelector('.reviews-submit-rating-value');
    const reviewsSubmitRatingButtons = Array.from(reviewsSubmitOverlay.querySelectorAll('.reviews-submit-rating-star'));
    const reviewsSubmitContentField = reviewsSubmitForm.elements.namedItem('content');
    const reviewsSubmitContentCount = reviewsSubmitOverlay.querySelector('.reviews-submit-content-count');
    const reviewsSubmitMediaDropzone = reviewsSubmitOverlay.querySelector('.reviews-submit-media-dropzone');
    const reviewsSubmitMediaInput = reviewsSubmitOverlay.querySelector('.reviews-submit-media-input');
    const reviewsSubmitMediaPreviews = reviewsSubmitOverlay.querySelector('.reviews-submit-media-previews');
    const reviewsSubmitMediaButton = reviewsSubmitOverlay.querySelector('.reviews-submit-media-button');
    const reviewsSubmitStatus = reviewsSubmitOverlay.querySelector('.reviews-submit-status');
    const reviewsSubmitSend = reviewsSubmitOverlay.querySelector('.reviews-submit-send');
    const klaviyoReviewCompanyId = reviewsRoot.dataset.klaviyoCompanyId || '';
    const klaviyoReviewProductId = reviewsRoot.dataset.klaviyoProductId || '';
    const submitReviewMaxImages = 5;
    const submitReviewMaxImageSize = 12 * 1024 * 1024;
    const submitReviewMaxBodySize = 4900000;
    const submitReviewMaxImageDataUrlSize = 800000;
    const submitReviewImageCompressionSteps = [
      { dimension: 1400, quality: 0.78 },
      { dimension: 1100, quality: 0.72 },
      { dimension: 900, quality: 0.66 },
      { dimension: 720, quality: 0.6 }
    ];
    const submitReviewAllowedImageTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
    const submitReviewContentMaxLength = Number.parseInt(reviewsSubmitContentField.getAttribute('maxlength'), 10) || 255;
    const submitReviewDefaultTitle = reviewsSubmitTitle.textContent;
    const submitReviewSuccessTitle = 'Thank You';
    const reviewsRatingFilter = reviewsRoot.querySelector('.reviews-rating-filter');
    const reviewsRatingLabel = reviewsRoot.querySelector('[data-reviews-rating-label]');
    const reviewsVisibleCount = reviewsRoot.querySelector('[data-reviews-visible-count]');
    const reviewsEmptyMessage = reviewsSwiperEl ? reviewsSwiperEl.querySelector('.reviews-empty-message') : null;
    const reviewSlides = reviewsSwiper ? Array.from(reviewsSwiper.slides) : [];
    const reviewsPageSize = 20;
    const reviewsLoadMoreSlide = document.createElement('div');
    reviewsLoadMoreSlide.className = 'reviews-load-more-slide swiper-slide';
    reviewsLoadMoreSlide.innerHTML = '<button class="reviews-load-more-button" type="button">Load More</button>';
    let activeReviewModalTrigger = null;
    let activeSubmitReviewTrigger = null;
    let reviewModalSwiperTranslate = null;
    let submitReviewImages = [];
    let submitReviewMediaPromise = Promise.resolve();
    let loadedReviewCount = reviewsPageSize;

    // NORMALIZE RATINGS AND STARS
    const normalizeRating = (rating) => {
      const parsedRating = Number.parseFloat(rating);
      if (Number.isNaN(parsedRating)) return 5;

      return Math.round(Math.min(5, Math.max(0, parsedRating)) * 2) / 2;
    };
    const formatRating = (rating) => Number.isInteger(rating) ? `${rating}` : `${rating}`;
    const createStarEl = (fill) => {
      const starEl = document.createElement('span');
      starEl.className = 'review-star';
      starEl.style.setProperty('--star-fill', `${fill}%`);
      starEl.setAttribute('aria-hidden', 'true');
      starEl.innerHTML = `
        <svg class="review-star-base" viewBox="0 0 17 16" focusable="false">
          <use href="#review-star-shape"></use>
        </svg>
        <span class="review-star-fill">
          <svg viewBox="0 0 17 16" focusable="false">
            <use href="#review-star-shape"></use>
          </svg>
        </span>
      `;
      return starEl;
    };
    const renderReviewStars = (rating) => {
      if (!reviewsReadMoreStars) return;

      const normalizedRating = normalizeRating(rating);
      const ratingLabel = formatRating(normalizedRating);
      reviewsReadMoreStars.textContent = '';
      reviewsReadMoreStars.setAttribute('aria-label', `${ratingLabel} out of 5 stars`);

      for (let star = 1; star <= 5; star++) {
        const starFill = normalizedRating >= star ? 100 : normalizedRating > star - 1 ? 50 : 0;
        reviewsReadMoreStars.append(createStarEl(starFill));
      }
    };
    const restoreReviewsSwiperPosition = (translate) => {
      if (!reviewsSwiper) return;
      if (!Number.isFinite(translate)) return;

      reviewsSwiper.setTranslate(translate);
      reviewsSwiper.updateProgress(translate);
      reviewsSwiper.updateActiveIndex();
      reviewsSwiper.updateSlidesClasses();

      if (reviewsSwiper.scrollbar && typeof reviewsSwiper.scrollbar.setTranslate === 'function') {
        reviewsSwiper.scrollbar.setTranslate();
      }
    };
    const focusWithoutScrolling = (element) => {
      if (!element) return;

      try {
        element.focus({ preventScroll: true });
      } catch {
        element.focus();
      }
    };
    const focusReviewModalTrigger = () => focusWithoutScrolling(activeReviewModalTrigger);

    // MANAGE REVIEW AND SUBMISSION MODALS
    const closeReadMoreReview = () => {
      if (!reviewsReadMoreOverlay) return;
      if (!reviewsReadMoreOverlay.classList.contains('active')) return;

      const closeSwiperTranslate = reviewModalSwiperTranslate;

      reviewsReadMoreOverlay.classList.remove('active');
      reviewsReadMoreOverlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('stuck');

      focusReviewModalTrigger();
      restoreReviewsSwiperPosition(closeSwiperTranslate);
      window.requestAnimationFrame(() => restoreReviewsSwiperPosition(closeSwiperTranslate));

      activeReviewModalTrigger = null;
      reviewModalSwiperTranslate = null;
    };
    const focusSubmitReviewTrigger = () => focusWithoutScrolling(activeSubmitReviewTrigger);
    const setSubmitReviewTitle = (title = submitReviewDefaultTitle) => {
      reviewsSubmitTitle.textContent = title;
    };
    const setSubmitReviewStatus = (message = '', type = '') => {
      reviewsSubmitStatus.textContent = message;
      reviewsSubmitStatus.hidden = !message;
      reviewsSubmitStatus.classList.toggle('is-error', type === 'error');
      reviewsSubmitStatus.classList.toggle('is-success', type === 'success');
    };
    const updateSubmitReviewContentCount = () => {
      const contentLength = reviewsSubmitContentField.value.length;
      reviewsSubmitContentCount.textContent = `${contentLength} / ${submitReviewContentMaxLength}`;
      reviewsSubmitContentCount.classList.toggle('is-error', contentLength > submitReviewContentMaxLength);
    };
    const setSubmitReviewRating = (rating) => {
      const selectedRating = Math.min(5, Math.max(1, Number.parseInt(rating, 10) || 5));

      reviewsSubmitRatingValue.value = `${selectedRating}`;
      reviewsSubmitRatingButtons.forEach((button) => {
        const buttonRating = Number.parseInt(button.dataset.rating, 10);
        button.classList.toggle('is-active', buttonRating <= selectedRating);
        button.setAttribute('aria-checked', buttonRating === selectedRating ? 'true' : 'false');
        button.tabIndex = buttonRating === selectedRating ? 0 : -1;
      });
    };
    const getSubmitReviewImageId = () => `review-image-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const getSubmitReviewByteSize = (value) => new Blob([value]).size;

    // PREPARE SUBMITTED REVIEW MEDIA
    const readFileAsDataUrl = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    };
    const loadSubmitReviewImage = (dataUrl) => {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = dataUrl;
      });
    };
    const resizeSubmitReviewImage = (image, dimension, quality) => {
      const scale = Math.min(1, dimension / Math.max(image.naturalWidth, image.naturalHeight));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
      canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));

      const context = canvas.getContext('2d');
      if (!context) return '';

      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0, canvas.width, canvas.height);

      return canvas.toDataURL('image/jpeg', quality);
    };
    const prepareSubmitReviewImage = async (file) => {
      const originalDataUrl = await readFileAsDataUrl(file);
      if (getSubmitReviewByteSize(originalDataUrl) <= submitReviewMaxImageDataUrlSize) return originalDataUrl;

      const image = await loadSubmitReviewImage(originalDataUrl);
      let smallestDataUrl = originalDataUrl;

      for (const step of submitReviewImageCompressionSteps) {
        const resizedDataUrl = resizeSubmitReviewImage(image, step.dimension, step.quality);
        if (!resizedDataUrl) continue;

        if (getSubmitReviewByteSize(resizedDataUrl) < getSubmitReviewByteSize(smallestDataUrl)) {
          smallestDataUrl = resizedDataUrl;
        }

        if (getSubmitReviewByteSize(resizedDataUrl) <= submitReviewMaxImageDataUrlSize) {
          return resizedDataUrl;
        }
      }

      return getSubmitReviewByteSize(smallestDataUrl) <= submitReviewMaxImageDataUrlSize ? smallestDataUrl : null;
    };
    const renderSubmitReviewMedia = () => {
      reviewsSubmitMediaPreviews.textContent = '';
      reviewsSubmitMediaDropzone.classList.toggle('has-files', submitReviewImages.length > 0);

      submitReviewImages.forEach((image) => {
        const preview = document.createElement('span');
        preview.className = 'reviews-submit-media-preview';

        const previewImage = document.createElement('img');
        previewImage.src = image.dataUrl;
        previewImage.alt = '';

        const removeButton = document.createElement('button');
        removeButton.className = 'reviews-submit-media-remove';
        removeButton.type = 'button';
        removeButton.dataset.imageId = image.id;
        removeButton.setAttribute('aria-label', `Remove ${image.name}`);
        removeButton.textContent = 'x';

        preview.append(previewImage, removeButton);
        reviewsSubmitMediaPreviews.append(preview);
      });
    };
    const clearSubmitReviewImages = () => {
      submitReviewImages = [];
      reviewsSubmitMediaInput.value = '';
      renderSubmitReviewMedia();
    };
    const addSubmitReviewFiles = (fileList) => {
      submitReviewMediaPromise = (async () => {
        const files = Array.from(fileList);
        if (!files.length) return;

        const availableSlots = submitReviewMaxImages - submitReviewImages.length;
        if (availableSlots <= 0) {
          setSubmitReviewStatus(`You can add up to ${submitReviewMaxImages} images.`, 'error');
          return;
        }

        const imageFiles = files.filter((file) => submitReviewAllowedImageTypes.includes(file.type));
        const filesToAdd = imageFiles.slice(0, availableSlots);
        const skippedCount = files.length - filesToAdd.length;
        let rejectedForSize = false;
        let rejectedForRead = false;

        setSubmitReviewStatus('Preparing images...', '');

        for (const file of filesToAdd) {
          if (file.size > submitReviewMaxImageSize) {
            rejectedForSize = true;
            continue;
          }

          submitReviewImages.push({
            id: getSubmitReviewImageId(),
            name: file.name,
            dataUrl: await prepareSubmitReviewImage(file).catch(() => {
              rejectedForRead = true;
              return null;
            })
          });
        }

        submitReviewImages = submitReviewImages.filter((image) => image.dataUrl);

        renderSubmitReviewMedia();

        if (rejectedForSize || rejectedForRead) {
          setSubmitReviewStatus('Some images were skipped. Please use smaller JPG, PNG, WebP, or GIF images.', 'error');
        } else if (skippedCount > 0) {
          setSubmitReviewStatus(`Only ${submitReviewMaxImages} images can be added. Extra or unsupported files were skipped.`, 'error');
        } else {
          setSubmitReviewStatus();
        }
      })();

      return submitReviewMediaPromise;
    };
    const focusSubmitReviewRating = () => {
      const selectedRatingButton = reviewsSubmitRatingButtons.find((button) => button.getAttribute('aria-checked') === 'true');
      focusWithoutScrolling(selectedRatingButton || reviewsSubmitRatingButtons[reviewsSubmitRatingButtons.length - 1]);
    };
    const setSubmitReviewLoading = (isLoading) => {
      reviewsSubmitForm.classList.toggle('is-loading', isLoading);
      Array.from(reviewsSubmitForm.elements).forEach((field) => {
        field.disabled = isLoading;
      });
      reviewsSubmitRatingButtons.forEach((button) => {
        button.disabled = isLoading;
      });
      reviewsSubmitSend.textContent = isLoading ? 'Submitting' : 'Submit';
    };
    const resetSubmitReviewForm = () => {
      reviewsSubmitForm.reset();
      reviewsSubmitForm.classList.remove('is-submitted');
      setSubmitReviewLoading(false);
      setSubmitReviewRating(5);
      clearSubmitReviewImages();
      submitReviewMediaPromise = Promise.resolve();
      updateSubmitReviewContentCount();
      setSubmitReviewTitle();
      setSubmitReviewStatus();
    };
    const closeSubmitReview = () => {
      if (!reviewsSubmitOverlay.classList.contains('active')) return;

      reviewsSubmitOverlay.classList.remove('active');
      reviewsSubmitOverlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('stuck');

      focusSubmitReviewTrigger();
      activeSubmitReviewTrigger = null;
    };
    const openSubmitReview = (trigger) => {
      closeReadMoreReview();
      activeSubmitReviewTrigger = trigger;
      resetSubmitReviewForm();
      reviewsSubmitOverlay.classList.add('active');
      reviewsSubmitOverlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('stuck');
      focusSubmitReviewRating();
    };
    const getSubmitReviewField = (name) => reviewsSubmitForm.elements.namedItem(name);
    const getSubmitReviewFieldValue = (name) => getSubmitReviewField(name).value.trim();

    // BUILD AND SEND KLAVIYO REVIEW PAYLOADS
    const getSubmitReviewPayload = () => {
      if (!reviewsSubmitForm.reportValidity()) {
        setSubmitReviewStatus('Please complete the required fields.', 'error');
        return null;
      }

      if (getSubmitReviewFieldValue('content').length > submitReviewContentMaxLength) {
        setSubmitReviewStatus(`Klaviyo accepts up to ${submitReviewContentMaxLength} characters for review text. Please shorten your review.`, 'error');
        focusWithoutScrolling(reviewsSubmitContentField);
        return null;
      }

      const rating = Number.parseInt(reviewsSubmitRatingValue.value, 10);
      if (!Number.isInteger(rating) || rating < 1 || rating > 5) {
        setSubmitReviewStatus('Please choose a rating.', 'error');
        focusSubmitReviewRating();
        return null;
      }

      return {
        data: {
          type: 'review',
          attributes: {
            review_type: 'review',
            email: getSubmitReviewFieldValue('email'),
            author: getSubmitReviewFieldValue('author'),
            content: getSubmitReviewFieldValue('content'),
            title: getSubmitReviewFieldValue('title'),
            rating,
            images: submitReviewImages.map((image) => image.dataUrl),
            product: {
              external_id: klaviyoReviewProductId,
              integration_key: 'shopify'
            }
          }
        }
      };
    };
    const getKlaviyoReviewErrorMessage = async (response) => {
      if (response.status === 429) return 'Too many attempts. Please wait a moment and try again.';

      try {
        const body = await response.json();
        const error = body.errors && body.errors[0];
        if (error && error.code === 'permission_denied') {
          return 'Klaviyo public review submissions are not enabled for company ID X9pTrM. Private Reviews API access works, but it cannot be used directly in the storefront.';
        }
        if (error && /Length of 'content' must be <= 255/i.test(error.detail || '')) {
          return 'Klaviyo accepts up to 255 characters for review text. Please shorten your review.';
        }
        if (error && /Request body size must be less than/i.test(error.detail || '')) {
          return 'Images are too large. Please upload smaller or fewer images.';
        }
        if (error && (error.detail || error.title)) return error.detail || error.title;
      } catch {
        return 'Something went wrong. Please try again.';
      }

      return 'Something went wrong. Please try again.';
    };
    const submitKlaviyoReview = async (event) => {
      event.preventDefault();

      await submitReviewMediaPromise;

      const payload = getSubmitReviewPayload();
      if (!payload) return;

      const requestBody = JSON.stringify(payload);
      if (getSubmitReviewByteSize(requestBody) > submitReviewMaxBodySize) {
        setSubmitReviewStatus('Images are too large. Please upload smaller or fewer images.', 'error');
        return;
      }

      setSubmitReviewStatus('Submitting...', '');
      setSubmitReviewLoading(true);

      try {
        const response = await fetch(`https://a.klaviyo.com/client/reviews?company_id=${encodeURIComponent(klaviyoReviewCompanyId)}`, {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            revision: '2026-04-15'
          },
          body: requestBody
        });

        if (response.status !== 202) {
          setSubmitReviewStatus(await getKlaviyoReviewErrorMessage(response), 'error');
          return;
        }

        reviewsSubmitForm.classList.add('is-submitted');
        reviewsSubmitForm.reset();
        setSubmitReviewRating(5);
        clearSubmitReviewImages();
        setSubmitReviewTitle(submitReviewSuccessTitle);
        setSubmitReviewStatus('Your review has been submitted!', 'success');
        focusWithoutScrolling(reviewsSubmitTitle);
      } catch (error) {
        console.error(error);
        setSubmitReviewStatus("Something went wrong. Please try again, or reach out to us, if you keep having trouble and we'll make it right!", 'error');
      } finally {
        setSubmitReviewLoading(false);
      }
    };
    const handleSubmitRatingKeydown = (event) => {
      const currentRating = Number.parseInt(reviewsSubmitRatingValue.value, 10) || 5;
      let nextRating = currentRating;

      if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
        nextRating = currentRating + 1;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
        nextRating = currentRating - 1;
      } else if (event.key === 'Home') {
        nextRating = 1;
      } else if (event.key === 'End') {
        nextRating = 5;
      } else {
        return;
      }

      event.preventDefault();
      setSubmitReviewRating(nextRating);
      focusSubmitReviewRating();
    };
    const openReviewModal = (trigger, {
      source = '',
      title = '',
      text = '',
      rating = '',
      reviewer = '',
      reviewerTitle = '',
      replyText = '',
      type = 'review'
    }) => {
      if (!reviewsReadMoreOverlay || !reviewsSwiper) return;

      const isReviewType = type === 'review-type';
      const hasReviewTitle = !isReviewType && title.trim() !== '';
      const hasReply = !isReviewType && replyText.trim() !== '';

      closeSubmitReview();
      activeReviewModalTrigger = trigger;
      reviewModalSwiperTranslate = reviewsSwiper.translate;
      reviewsReadMoreContent.classList.toggle('is-review-type', isReviewType);
      reviewsReadMoreStars.hidden = isReviewType;
      reviewsReadMoreInfoIcon.hidden = !isReviewType;
      reviewsReadMoreReviewerWrap.hidden = isReviewType;
      reviewsReadMoreSource.textContent = source;
      if (reviewsReadMoreTitle) {
        reviewsReadMoreTitle.hidden = !hasReviewTitle;
        reviewsReadMoreTitle.textContent = hasReviewTitle ? title : '';
      }
      reviewsReadMoreText.textContent = text;
      reviewsReadMoreReviewer.textContent = reviewer;
      reviewsReadMoreReviewerTitle.textContent = reviewerTitle;
      if (reviewsReadMoreReply) reviewsReadMoreReply.hidden = !hasReply;
      if (reviewsReadMoreReplyText) reviewsReadMoreReplyText.textContent = replyText;

      if (!isReviewType) renderReviewStars(rating);

      reviewsReadMoreOverlay.classList.add('active');
      reviewsReadMoreOverlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('stuck');
      focusWithoutScrolling(reviewsReadMoreClose);
    };
    const openReadMoreReview = (trigger) => {
      const reviewSlide = trigger.closest('.a-review');
      if (!reviewSlide) return;

      openReviewModal(trigger, {
        source: reviewSlide.dataset.reviewSource || '',
        title: reviewSlide.dataset.reviewTitle || '',
        text: reviewSlide.dataset.reviewBody || '',
        rating: reviewSlide.dataset.reviewRating,
        reviewer: reviewSlide.dataset.reviewReviewer || '',
        reviewerTitle: reviewSlide.dataset.reviewerTitle || '',
        replyText: reviewSlide.dataset.reviewReplyBody || ''
      });
    };
    const openReviewTypeDescription = (trigger) => {
      const reviewSlide = trigger.closest('.a-review');
      if (!reviewSlide) return;

      openReviewModal(trigger, {
        source: reviewSlide.dataset.reviewSource || '',
        text: reviewSlide.dataset.reviewSourceHelp || '',
        type: 'review-type'
      });
    };
    const getRatingFilterLabel = (rating) => `${rating} Star${rating === 1 ? '' : 's'} Only`;
    const getFilterLabel = (value) => value === 'all' ? 'All Ratings' : getRatingFilterLabel(Number.parseInt(value, 10));
    const ratingMatchesFilter = (rating, selectedRating) => {
      return rating >= selectedRating && rating < selectedRating + 1;
    };
    const getFilteredReviewSlides = () => {
      const selectedValue = reviewsRatingFilter.value;
      const selectedRating = Number.parseInt(selectedValue, 10);

      return selectedValue === 'all' ? reviewSlides : reviewSlides.filter((slide) => {
        const slideRating = normalizeRating(slide.dataset.reviewRating);
        return ratingMatchesFilter(slideRating, selectedRating);
      });
    };
    const setSwiperSlides = (slides, hasMore, targetIndex = 0) => {
      if (!reviewsSwiper) return;

      reviewsSwiper.removeAllSlides();

      if (slides.length) reviewsSwiper.appendSlide(slides);
      if (hasMore) reviewsSwiper.appendSlide(reviewsLoadMoreSlide);

      reviewsSwiper.params.slidesOffsetBefore = getReviewsOffset();
      reviewsSwiper.update();
      reviewsSwiper.slideTo(Math.min(targetIndex, Math.max(reviewsSwiper.slides.length - 1, 0)), 0);
    };
    const renderFilteredReviews = (targetIndex = 0) => {
      if (!reviewsRatingFilter || !reviewsSwiper || !reviewsSwiperEl) return;

      const selectedValue = reviewsRatingFilter.value;
      const filteredSlides = getFilteredReviewSlides();
      const activeReviewSlides = filteredSlides.slice(0, loadedReviewCount);
      const hasMoreReviews = filteredSlides.length > activeReviewSlides.length;

      if (reviewsRatingLabel) reviewsRatingLabel.textContent = getFilterLabel(selectedValue);

      reviewSlides.forEach((slide) => {
        const matches = activeReviewSlides.includes(slide);
        slide.hidden = false;
        slide.setAttribute('aria-hidden', matches ? 'false' : 'true');
      });

      if (reviewsVisibleCount) reviewsVisibleCount.textContent = filteredSlides.length;
      if (reviewsEmptyMessage) reviewsEmptyMessage.hidden = filteredSlides.length > 0;
      reviewsSwiperEl.classList.toggle('is-empty', filteredSlides.length === 0);

      setSwiperSlides(activeReviewSlides, hasMoreReviews, targetIndex);
    };
    const applyRatingFilter = () => {
      loadedReviewCount = reviewsPageSize;
      renderFilteredReviews();
    };

    // WIRE REVIEW CONTROLS
    if (reviewsSwiperEl) {
      reviewsSwiperEl.addEventListener('click', (event) => {
        const loadMoreTrigger = event.target.closest('.reviews-load-more-button');
        if (loadMoreTrigger && reviewsSwiperEl.contains(loadMoreTrigger)) {
          const targetIndex = loadedReviewCount;
          loadedReviewCount += reviewsPageSize;
          renderFilteredReviews(targetIndex);
          return;
        }

        const reviewSourceTrigger = event.target.closest('.review-source');
        if (reviewSourceTrigger && reviewsSwiperEl.contains(reviewSourceTrigger)) {
          openReviewTypeDescription(reviewSourceTrigger);
          return;
        }

        const readMoreTrigger = event.target.closest('.review-read-more');
        if (readMoreTrigger && reviewsSwiperEl.contains(readMoreTrigger)) {
          openReadMoreReview(readMoreTrigger);
        }
      });
    }
    if (reviewsSubmitButton) {
      reviewsSubmitButton.addEventListener('click', () => openSubmitReview(reviewsSubmitButton));
    }
    if (reviewsEmptyCta) {
      reviewsEmptyCta.addEventListener('click', (event) => {
        event.preventDefault();
        openSubmitReview(reviewsEmptyCta);
      });
    }
    reviewsSubmitRatingButtons.forEach((button) => {
      button.addEventListener('click', () => setSubmitReviewRating(button.dataset.rating));
      button.addEventListener('keydown', handleSubmitRatingKeydown);
    });
    reviewsSubmitContentField.addEventListener('input', updateSubmitReviewContentCount);
    reviewsSubmitMediaButton.addEventListener('click', () => reviewsSubmitMediaInput.click());
    reviewsSubmitMediaInput.addEventListener('change', (event) => {
      addSubmitReviewFiles(event.target.files);
      event.target.value = '';
    });
    reviewsSubmitMediaPreviews.addEventListener('click', (event) => {
      const removeButton = event.target.closest('.reviews-submit-media-remove');
      if (!removeButton) return;

      submitReviewImages = submitReviewImages.filter((image) => image.id !== removeButton.dataset.imageId);
      renderSubmitReviewMedia();
      setSubmitReviewStatus();
    });
    reviewsSubmitMediaDropzone.addEventListener('keydown', (event) => {
      if (event.target !== reviewsSubmitMediaDropzone) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      reviewsSubmitMediaInput.click();
    });
    ['dragenter', 'dragover'].forEach((eventName) => {
      reviewsSubmitMediaDropzone.addEventListener(eventName, (event) => {
        event.preventDefault();
        reviewsSubmitMediaDropzone.classList.add('is-dragover');
      });
    });
    ['dragleave', 'drop'].forEach((eventName) => {
      reviewsSubmitMediaDropzone.addEventListener(eventName, () => {
        reviewsSubmitMediaDropzone.classList.remove('is-dragover');
      });
    });
    reviewsSubmitMediaDropzone.addEventListener('drop', (event) => {
      event.preventDefault();
      addSubmitReviewFiles(event.dataTransfer.files);
    });
    reviewsSubmitClose.addEventListener('click', closeSubmitReview);
    reviewsSubmitOverlay.addEventListener('click', (event) => {
      if (event.target === reviewsSubmitOverlay) closeSubmitReview();
    });
    reviewsSubmitForm.addEventListener('submit', submitKlaviyoReview);
    setSubmitReviewRating(5);
    updateSubmitReviewContentCount();
    if (reviewsRatingFilter) {
      reviewsRatingFilter.addEventListener('change', () => {
        closeReadMoreReview();
        closeSubmitReview();
        applyRatingFilter();
      });
      applyRatingFilter();
    }

    if (reviewsReadMoreClose) {
      reviewsReadMoreClose.addEventListener('click', closeReadMoreReview);
    }
    if (reviewsReadMoreOverlay) {
      reviewsReadMoreOverlay.addEventListener('click', (event) => {
        if (event.target === reviewsReadMoreOverlay) closeReadMoreReview();
      });
    }
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeReadMoreReview();
        closeSubmitReview();
      }
    });
  };

  const initAllProductReviews = () => {
    document.querySelectorAll('.product-reviews').forEach(initProductReviews);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductReviews);
  } else {
    initAllProductReviews();
  }
})();
